import moment from "moment";

export default {
    methods:{
        findDiffDate(startDate,stopDate){
            var dateStart = moment(startDate).format("YYYY-MM-DD")  //moment([2007, 0, 29]);
            var dateStop = moment(stopDate).format("YYYY-MM-DD")
            var  diff = moment.duration(moment(dateStop).diff(moment(dateStart)))
            return parseInt(diff.asDays())

        }
    },



}